import {TemplateDataFields} from '@/Agent/ContactForm/EmailEditor/EmailEditor';
import API from '@/APIs/API';
import {ParameterStore} from '@/Core/mobx/ParameterStore/ParameterStore';

export const adbAPI = async (parameterStore: ParameterStore) => {
    const {quote, prequal} = parameterStore;

    const applicantAge = prequal.age.value;
    const applicantGender = prequal.gender.value;
    const rop = quote.returnOnPremiumADB.value;
    const coverage = quote.specifiedCoverageADB.value;
    const planType = quote.planTypeADB.value;
    const includeChildren = quote.includeChildrenADB.value;
    const secondCoveredAdultAge = quote.secondCoveredAdultAgeADB.value;

    let premiumTable: Record<string, number[]> | null = null;
    let lookupAge: number = applicantAge;

    try {
        if (planType === '_1Adult') {
            if (applicantGender === 'Male') {
                if (includeChildren) {
                    if (rop) {
                        premiumTable = await API.RequestToThisOrigin(
                            `./adb-quotes/male-1adult-children-rop.json?v=${ParameterStore.version}`,
                            'GET',
                            undefined,
                        );
                    } else {
                        premiumTable = await API.RequestToThisOrigin(
                            `./adb-quotes/male-1adult-children.json?v=${ParameterStore.version}`,
                            'GET',
                            undefined,
                        );
                    }
                } else {
                    if (rop) {
                        premiumTable = await API.RequestToThisOrigin(
                            `./adb-quotes/male-individual-rop.json?v=${ParameterStore.version}`,
                            'GET',
                            undefined,
                        );
                    } else {
                        premiumTable = await API.RequestToThisOrigin(
                            `./adb-quotes/male-individual.json?v=${ParameterStore.version}`,
                            'GET',
                            undefined,
                        );
                    }
                }
            } else {
                if (includeChildren) {
                    if (rop) {
                        premiumTable = await API.RequestToThisOrigin(
                            `./adb-quotes/female-1adult-children-rop.json?v=${ParameterStore.version}`,
                            'GET',
                            undefined,
                        );
                    } else {
                        premiumTable = await API.RequestToThisOrigin(
                            `./adb-quotes/female-1adult-children.json?v=${ParameterStore.version}`,
                            'GET',
                            undefined,
                        );
                    }
                } else {
                    if (rop) {
                        premiumTable = await API.RequestToThisOrigin(
                            `./adb-quotes/female-individual-rop.json?v=${ParameterStore.version}`,
                            'GET',
                            undefined,
                        );
                    } else {
                        premiumTable = await API.RequestToThisOrigin(
                            `./adb-quotes/female-individual.json?v=${ParameterStore.version}`,
                            'GET',
                            undefined,
                        );
                    }
                }
            }
        } else {
            if (rop) {
                if (includeChildren) {
                    premiumTable = await API.RequestToThisOrigin(
                        `./adb-quotes/family-2adult-children-rop.json?v=${ParameterStore.version}`,
                        'GET',
                        undefined,
                    );
                } else {
                    premiumTable = await API.RequestToThisOrigin(
                        `./adb-quotes/family-2adult-nochildren-rop.json?v=${ParameterStore.version}`,
                        'GET',
                        undefined,
                    );
                }
            } else {
                const maleAge = applicantGender === 'Male' ? applicantAge : secondCoveredAdultAge;
                const femaleAge = applicantGender === 'Male' ? secondCoveredAdultAge : applicantAge;
                lookupAge = femaleAge;

                if (maleAge >= 18 && maleAge <= 50) {
                    if (includeChildren) {
                        premiumTable = await API.RequestToThisOrigin(
                            `./adb-quotes/male1850-2adult-children.json?v=${ParameterStore.version}`,
                            'GET',
                            undefined,
                        );
                    } else {
                        premiumTable = await API.RequestToThisOrigin(
                            `./adb-quotes/male1850-2adult-nochildren.json?v=${ParameterStore.version}`,
                            'GET',
                            undefined,
                        );
                    }
                } else if (maleAge >= 51 && maleAge <= 60) {
                    if (includeChildren) {
                        premiumTable = await API.RequestToThisOrigin(
                            `./adb-quotes/male5160-2adult-children.json?v=${ParameterStore.version}`,
                            'GET',
                            undefined,
                        );
                    } else {
                        premiumTable = await API.RequestToThisOrigin(
                            `./adb-quotes/male5160-2adult-nochildren.json?v=${ParameterStore.version}`,
                            'GET',
                            undefined,
                        );
                    }
                } else if (maleAge >= 61 && maleAge <= 70) {
                    if (includeChildren) {
                        premiumTable = await API.RequestToThisOrigin(
                            `./adb-quotes/male6170-2adult-children.json?v=${ParameterStore.version}`,
                            'GET',
                            undefined,
                        );
                    } else {
                        premiumTable = await API.RequestToThisOrigin(
                            `./adb-quotes/male6170-2adult-nochildren.json?v=${ParameterStore.version}`,
                            'GET',
                            undefined,
                        );
                    }
                }
            }
        }
    } catch (error) {
        console.error('Failed to load ADB premium table. Please try again.');
        return null;
    }

    if (!premiumTable || !lookupAge) {
        console.error('Failed to load ADB premium table. Please try again.');
        return null;
    }

    const premium = premiumTable[lookupAge.toString()][Number(coverage) / 50000 - 1];

    return {
        faceAmount: coverage,
        monthlyPremium: premium,
        productName: quote.productADB.valueAsString(),
        out: [
            {
                name: 'Carrier',
                value: 'Mutual of Omaha',
                type: 'string',
                fieldName: TemplateDataFields.carrier,
            },
            {
                name: 'Product',
                value: 'ADB',
                type: 'string',
                fieldName: 'product',
            },
            {
                name: 'Product name',
                value: quote.productADB.valueAsString(),
                type: 'string',
                fieldName: TemplateDataFields.productName,
            },
            {
                name: 'Gender',
                value: applicantGender,
                type: 'string',
                fieldName: 'gender',
            },
            {
                name: 'Monthly premium',
                value: premium,
                type: 'currency',
                fieldName: TemplateDataFields.monthlyPremium,
            },
            {
                name: 'Annual premium',
                value: premium * 12,
                type: 'currency',
                fieldName: 'annualPremium',
            },
            {
                name: 'Death benefit',
                value: coverage,
                type: 'currency',
                fieldName: TemplateDataFields.faceAmount,
            },
            {
                name: 'Valid',
                value: 'valid',
                type: 'string',
            },
        ],
        requestDetails: {
            applicantAge,
            applicantGender,
            rop,
            coverage,
            planType,
            includeChildren,
            secondCoveredAdultAge,
        },
    };
};
